import {EditableFieldModel} from "@white-label/components/page-builder/models/edit-component.model";
import {FieldType} from "@white-label/components/page-builder/models/model.map";

export class DonationWidgetModel {
    price =new EditableFieldModel('price', FieldType.array, [
        new PricesModel({value: 50}),
        new PricesModel({value: 200}),
        new PricesModel({value: 1000}),
    ], PricesModel);

    fieldsMap = [
        this.price,
    ];


    constructor(data?: {
        price: any}) {
        if(data?.price){
            this.price.value = [];
            for(let key in data?.price.value){
                this.price.value.push(new PricesModel({ value: data?.price.value[key].value.value}));
            }
        }

    }
}

export class PricesModel {
    value = new EditableFieldModel('value_of_prices', FieldType.number, 1)

    fieldsMap = [this.value];

    constructor(data?: { value?: number}) {
        if (data?.value) {
            this.value.value = data.value;
        }
    }

}